var _defs, _rect, _rect2, _rect3, _g, _g2, _g3, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamilyDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 200,
    viewBox: "0 0 800 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "familyGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#8E24AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5E35B1"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "homePattern",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,10 L50,25 L50,50 L10,50 L10,25 Z",
    fill: "none",
    stroke: "#E1BEE7",
    strokeWidth: 1,
    opacity: 0.2
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 200,
    rx: 10,
    fill: "url(#familyGradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 200,
    rx: 10,
    fill: "url(#homePattern)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 780,
    height: 180,
    rx: 5,
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 2,
    strokeDasharray: "5 5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(120, 100)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -40,
    cy: -30,
    r: 15,
    fill: "#FFF",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50,-5 C-60,20 -40,45 -40,45 C-40,45 -20,20 -30,-5",
    fill: "#FFF",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: -30,
    r: 15,
    fill: "#FFF",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,-5 C20,20 40,45 40,45 C40,45 60,20 50,-5",
    fill: "#FFF",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -15,
    cy: -10,
    r: 10,
    fill: "#FFF",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20,5 C-25,20 -15,35 -15,35 C-15,35 -5,20 -10,5",
    fill: "#FFF",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: -10,
    r: 10,
    fill: "#FFF",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,5 C5,20 15,35 15,35 C15,35 25,20 20,5",
    fill: "#FFF",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-30,-5 L-20,5 M-10,5 L10,5 M20,5 L30,-5",
    stroke: "#FFF",
    strokeWidth: 2,
    opacity: 0.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(650, 100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-50 L60,0 L60,50 L-60,50 L-60,0 Z",
    fill: "#E1BEE7",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,-50 L60,0 L-60,0 Z",
    fill: "#CE93D8",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: 15,
    width: 30,
    height: 35,
    fill: "#4A148C",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 30,
    r: 3,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -45,
    y: 15,
    width: 20,
    height: 20,
    fill: "#F3E5F5",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 15,
    width: 20,
    height: 20,
    fill: "#F3E5F5",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45,25 L-25,25 M-35,15 L-35,35",
    stroke: "#7B1FA2",
    strokeWidth: 1,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,25 L45,25 M35,15 L35,35",
    stroke: "#7B1FA2",
    strokeWidth: 1,
    opacity: 0.7
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M220,40 C215,30 200,30 200,45 C200,60 220,70 220,70 C220,70 240,60 240,45 C240,30 225,30 220,40 Z",
    fill: "#CE93D8",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580,40 C575,30 560,30 560,45 C560,60 580,70 580,70 C580,70 600,60 600,45 C600,30 585,30 580,40 Z",
    fill: "#CE93D8",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,170 C397,165 390,165 390,173 C390,180 400,185 400,185 C400,185 410,180 410,173 C410,165 403,165 400,170 Z",
    fill: "#CE93D8",
    opacity: 0.6
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 75,
    fontFamily: "Arial, sans-serif",
    fontSize: 35,
    fontWeight: "bold",
    fill: "#FFF",
    textAnchor: "middle"
  }, "FAMILY DISCOUNT")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 115,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fill: "#E1BEE7",
    textAnchor: "middle"
  }, "15% OFF")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 145,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fill: "#FFF",
    textAnchor: "middle"
  }, "For families shopping together")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyDiscount);
export default __webpack_public_path__ + "static/media/family_discount.983872dc9f7c71d5f6d9564c14b3c06c.svg";
export { ForwardRef as ReactComponent };